/**
 * assets/mega-nav.js
 * Mega navigation for mitoredlight.com
 * Simplified: no hover preview behavior
 */

(function () {
  'use strict';

  const container = document.getElementById('mega-nav-container');
  const overlay = document.getElementById('mega-nav-overlay');
  const navZone = document.getElementById('main-navigation-container');
  const header = document.querySelector('.site-header, .header');
  const navItems = document.querySelectorAll('.site-header__nav .nav-item');

  if (!container || !overlay || !navItems.length) return;

  const PANEL_MAP = {
    'Shop Lights': 'mn-panel-lights',
    'Skincare': 'mn-panel-skincare',
    'Portable': 'mn-panel-portable',
  };

  const CLICK_MAP = {
    'Shop Lights': '/collections/red-light-therapy',
    'Skincare': '/collections/topical',
    'Portable': '/collections/portable-devices',
  };

  const TRIGGER_LABELS = Object.keys(PANEL_MAP);

  let currentPanel = null;
  let hideTimer = null;
  let suppressFocusOpen = false;
  const panelIdToAnchor = {};

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function getLabel(item) {
    return item.querySelector('a')?.textContent?.trim() || '';
  }

  function setOverlayTop() {
    if (!header) return;
    const rect = header.getBoundingClientRect();
    overlay.style.top = `${Math.round(rect.bottom)}px`;
  }

  function closeAll() {
    clearTimeout(hideTimer);
    container.classList.remove('mn-open');
    overlay.classList.remove('mn-open');

    document.querySelectorAll('.mn-panel').forEach((panel) => {
      panel.classList.remove('mn-active');
    });

    navItems.forEach((item) => {
      item.classList.remove('mn-nav-active', 'mn-mobile-open');
      const anchor = item.querySelector('a');
      if (anchor && PANEL_MAP[getLabel(item)]) {
        anchor.setAttribute('aria-expanded', 'false');
      }
    });

    currentPanel = null;
  }

  function isInsideNavZone(el) {
  if (!el) return false;
  // Non-mega-nav nav items (e.g. Learn) must not keep the panel open
  const asNavItem = el.closest?.('.site-header__nav .nav-item');
  if (asNavItem && !PANEL_MAP[getLabel(asNavItem)]) return false;
  return !!(
    container.contains(el) ||
    navZone?.contains(el) ||
    el.closest?.('#mega-nav-container') ||
    el.closest?.('#main-navigation-container') ||
    el.closest?.('.site-header__nav')
  );
}

  function hideLegacyDropdowns() {
    document.querySelectorAll('.lights-navigation, .submenu, .site-nav__dropdown, .dropdown-menu').forEach((el) => {
      el.style.display = 'none';
      el.classList.remove('active', 'open', 'is-open');
    });
  }

  function openPanel(panelId) {
    clearTimeout(hideTimer);

    const panel = document.getElementById(panelId);
    if (!panel) return;

    document.querySelectorAll('.mn-panel').forEach((p) => {
      p.classList.remove('mn-active');
    });

    panel.classList.add('mn-active');
    container.classList.add('mn-open');
    overlay.classList.add('mn-open');
    currentPanel = panelId;

    navItems.forEach((item) => {
      const label = getLabel(item);
      const isActive = PANEL_MAP[label] === panelId;
      item.classList.toggle('mn-nav-active', isActive);
      item.classList.toggle('mn-mobile-open', isActive && !isDesktop());
      const anchor = item.querySelector('a');
      if (anchor && PANEL_MAP[label]) {
        anchor.setAttribute('aria-expanded', String(isActive));
      }
    });

    hideLegacyDropdowns();
    setOverlayTop();
  }

  function scheduleClose(relatedTarget) {
    if (!isDesktop()) return;
    if (isInsideNavZone(relatedTarget)) return;

    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      closeAll();
    }, 120);
  }

  function cancelClose() {
    clearTimeout(hideTimer);
  }

  navItems.forEach((item) => {
    const anchor = item.querySelector('a');
    if (!anchor) return;

    const label = getLabel(item);
    const panelId = PANEL_MAP[label];
    const url = CLICK_MAP[label];

    if (url) anchor.href = url;
    if (!panelId) {                
      item.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        if (currentPanel) {
          clearTimeout(hideTimer);
          closeAll();
        }
      });
      return;
    }

    item.removeAttribute('onmouseenter');
    item.removeAttribute('onmouseleave');
    anchor.removeAttribute('onmouseenter');
    anchor.removeAttribute('onmouseleave');

    panelIdToAnchor[panelId] = anchor;

    item.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      openPanel(panelId);
    });

    item.addEventListener('mouseleave', (e) => {
      if (!isDesktop()) return;
      scheduleClose(e.relatedTarget);
    });

    anchor.addEventListener('focus', () => {
      if (!isDesktop() || suppressFocusOpen) return;
      openPanel(panelId);
    });

    // Tab naturally continues through the top-level nav items (the panel
    // lives later in the DOM, not right after the trigger) - ArrowDown is
    // the deliberate way to descend into the open panel's content.
    anchor.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' || !isDesktop()) return;
      if (currentPanel !== panelId) openPanel(panelId);
      const panel = document.getElementById(panelId);
      const firstFocusable = panel && panel.querySelector('a, button');
      if (firstFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    });

    anchor.addEventListener('click', (e) => {
      if (isDesktop()) return;

      const thisLabel = getLabel(item);
      const thisPanelId = PANEL_MAP[thisLabel];
      if (!thisPanelId) return;

      if (currentPanel !== thisPanelId) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }

        closeAll();
        openPanel(thisPanelId);
        hideLegacyDropdowns();
        return false;
      }
    });
  });
  container.addEventListener('mouseenter', () => {
    if (!isDesktop()) return;
    cancelClose();
  });

  container.addEventListener('mouseleave', (e) => {
    if (!isDesktop()) return;
    scheduleClose(e.relatedTarget);
  });

  if (navZone) {
    navZone.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      cancelClose();
    });

    navZone.addEventListener('mouseleave', (e) => {
      if (!isDesktop()) return;
      scheduleClose(e.relatedTarget);
    });
  }

  overlay.addEventListener('click', closeAll);

  document.addEventListener('focusin', (e) => {
    if (!isDesktop()) return;
    if (isInsideNavZone(e.target)) {
      cancelClose();
    } else if (currentPanel) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && currentPanel) {
      const anchor = panelIdToAnchor[currentPanel];
      closeAll();
      if (anchor) {
        suppressFocusOpen = true;
        anchor.focus();
        suppressFocusOpen = false;
      }
    }
  });

  document.querySelectorAll('.mn-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabId = tab.dataset.tab;
      const panel = tab.closest('.mn-panel');
      if (!panel) return;

      panel.querySelectorAll('.mn-tab').forEach((t) => t.classList.remove('mn-tab-active'));
      panel.querySelectorAll('.mn-tab-panel').forEach((p) => p.classList.remove('mn-tab-active'));

      tab.classList.add('mn-tab-active');

      const target = panel.querySelector('#mn-tab-' + tabId);
      if (target) target.classList.add('mn-tab-active');
    });
  });

  const _origShow = window.showDropdown;
  window.showDropdown = function (element) {
    const label =
      element?.innerText?.trim() ||
      element?.querySelector('a')?.textContent?.trim() ||
      '';
    if (TRIGGER_LABELS.includes(label)) return;
    if (typeof _origShow === 'function') _origShow.call(this, element);
  };

  const _origHide = window.hideDropdown;
  window.hideDropdown = function (element) {
    const label =
      element?.innerText?.trim() ||
      element?.querySelector('a')?.textContent?.trim() ||
      '';
    if (TRIGGER_LABELS.includes(label)) return;
    if (typeof _origHide === 'function') _origHide.call(this, element);
  };

  window.addEventListener('resize', () => {
    setOverlayTop();

    if (isDesktop()) {
      navItems.forEach((item) => item.classList.remove('mn-mobile-open'));
    } else {
      closeAll();
      hideLegacyDropdowns();
    }
  });

  window.addEventListener('load', () => {
    setOverlayTop();
    hideLegacyDropdowns();
  });

  setOverlayTop();
})();